import parseQueryString from '../../_utils/parse-query-string';
import Store from '../../_utils/tools/store';

export default function jsonDataURL(baseURL) {
  if(Store.isWalmart()) {
    return jsonDataURLWalmart(baseURL);
  }

  return jsonDataURLGeneric(baseURL);
}

function jsonDataURLGeneric(baseURL) {
  const finishParam = (parseQueryString()['finish-include'] || '').toLowerCase();

  if (finishParam != "") {
    return `${baseURL}?finish-include=${finishParam}`;
  }

  return baseURL;
};

function jsonDataURLWalmart(baseURL) {
  const finishParam = (parseQueryString().finish || '').toLowerCase();
  const excludedFinishes = ['metallic', 'stressed'];

  return excludedFinishes.indexOf(finishParam) === -1
    // by default, exclude these finishes...
    ? `${baseURL}?finish-exclude=${excludedFinishes.join(',')}`
    // but, include them if they are explicitly asked for (for some reason)
    : `${baseURL}?finish-include=${finishParam}`;
};